import React from 'react';
import { Typography } from '@mui/material';

/**
 * R4-3 (P11 generalized): shared freshness caption under every time-series —
 * extracted from the payments R2-3 caption so all charts state the same bound.
 */
export function DataThroughCaption({
  dataThrough,
  partial = false,
  testId,
}: {
  dataThrough?: string;
  /** The freshness bound falls inside the last plotted day (dashed tail). */
  partial?: boolean;
  testId: string;
}): React.ReactElement | null {
  if (!dataThrough) return null;
  return (
    <Typography variant="caption" color="text.secondary" component="div" data-testid={testId} sx={{ mb: 1 }}>
      Data through {dataThrough.slice(0, 16).replace('T', ' ')} UTC{partial ? ' — the last day is partial' : ''}.
    </Typography>
  );
}
